// see date formats here https://day.js.org/docs/en/display/format
import {PLACEHOLDER, ROUND_OPTION} from "./const";

const SPACE = '&nb[s]p';

export const LANG_SETTING = {
    ru: {
        DateText: `${PLACEHOLDER.DateFormat}`,
        DateFormat: `в${SPACE}${PLACEHOLDER.MonthFormat}`,
        MinLosText: `${PLACEHOLDER.MinLos}${PLACEHOLDER.MinLosDayEnd} ${PLACEHOLDER.MinLosDay}`,
        OfferText: `по тарифу «${PLACEHOLDER.Offer}»`,
        AdultsText: `на ${PLACEHOLDER.Adults}${PLACEHOLDER.AdultsEnd}`,
        UsePriceRound: ROUND_OPTION.No,
        UsePriceSplit: true,
        PriceDelimiter: ',', // by default is dot
    },
    en: {
        DateText: `${PLACEHOLDER.DateFormat}`,
        DateFormat: `in${SPACE}${PLACEHOLDER.MonthFormat}`,
        MinLosText: `${PLACEHOLDER.MinLos} ${PLACEHOLDER.MinLosDay}`,
        OfferText: `on "${PLACEHOLDER.Offer}" special offer`,
        AdultsText: `${PLACEHOLDER.Adults}${PLACEHOLDER.AdultsEnd}`,
        UsePriceRound: ROUND_OPTION.No,
        UsePriceSplit: true,
        PriceDelimiter: ',', // by default is dot
    },
    fr: {
        DateText: `${PLACEHOLDER.DateFormat}`,
        DateFormat: `en${SPACE}${PLACEHOLDER.MonthFormat}`,
        MinLosText: `${PLACEHOLDER.MinLos} ${PLACEHOLDER.MinLosDay}`,
        OfferText: `on "${PLACEHOLDER.Offer}" special offer`,
        AdultsText: `${PLACEHOLDER.Adults}${PLACEHOLDER.AdultsEnd}`,
        UsePriceRound: ROUND_OPTION.No,
        UsePriceSplit: true,
        PriceDelimiter: ',', // by default is dot
    }
};